import { render } from "./TextUs.vue?vue&type=template&id=56225415&scoped=true"
import script from "./TextUs.vue?vue&type=script&lang=js"
export * from "./TextUs.vue?vue&type=script&lang=js"

import "./TextUs.vue?vue&type=style&index=0&id=56225415&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56225415"],['__file',"src/components/Shared/TextUs/TextUs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56225415"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56225415', __exports__)) {
    api.reload('56225415', __exports__)
  }
  
  module.hot.accept("./TextUs.vue?vue&type=template&id=56225415&scoped=true", () => {
    api.rerender('56225415', render)
  })

}


export default __exports__